const decor = [
    {
        name: "Домашний декор",
        img: "./images/category/домашний декор.png"
        
        
    },
    {
        name: "Подушки & покрывала",
        img: "./images/category/подушки & покрывала.png"
    },

    { 
      name: "Коврики", 
      img: "./images/category/коврики.png"
    },
    { 
      name: "Освещение", 
      img: "./images/category/освещение.png"
    },
    { 
      name: "Зеркала", 
      img: "./images/category/зеркала.png"
    },
    
];

export default decor;
